(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PortDetailController', PortDetailController);

    PortDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Port', 'Country', '$uibModal'];

    function PortDetailController($scope, $rootScope, $stateParams, previousState, entity, Port, Country, $uibModal) {
        var vm = this;

        vm.port = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:portUpdate', function(event, result) {
            vm.port = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.createTab = function( data ) {
            $scope.$emit('handleEmit', data );
        };

        vm.getOrDash = function(val) {
            return (val && val !== null) ? val : '-';
        };

        vm.editPort = function() {
            $uibModal.open({
                templateUrl: 'app/entities/port/port-dialog.html',
                controller: 'PortDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: ['Port', function(Port) {
                        return Port.get({id : $stateParams.id}).$promise;
                    }]
                }
            }).result.then(function() {

            }, function() {

            });
        };
    }
})();
